/** Stop v1 (medium only): must match API ComputeStopQuestionPoints. */
export const STOP_REQUIRED_FINDS = 3;
export const STOP_MAX_WRONG = 3;
export const STOP_MAX_POINTS_PER_QUESTION = 10;
export const STOP_TIME_LIMIT_SECONDS = 30;

/** Base letter score from find count only (0→0, 1→2, 2→6, 3+→10). */
export function stopQuestionPoints(foundCount: number): number {
  const n = Math.max(0, foundCount);
  if (n >= STOP_REQUIRED_FINDS) return STOP_MAX_POINTS_PER_QUESTION;
  if (n === 2) return 6;
  if (n === 1) return 2;
  return 0;
}

/** Letter score = table points for finds minus 1 per wrong (floor 0). Matches API ComputeStopLetterPoints. */
export function stopLetterPointsFromProgress(foundCount: number, wrongCount: number): number {
  const base = stopQuestionPoints(foundCount);
  const wrong = Math.max(0, wrongCount);
  return Math.max(0, base - wrong);
}

export type StopValidateAnswerLike = {
  correct: boolean;
  duplicate: boolean;
  foundCount: number;
  wrongCount: number;
  questionPointsSoFar?: number;
};

/** Prefer server value; fallback uses found + wrong counts (same formula as API). */
export function resolveStopLetterPointsFromValidate(res: StopValidateAnswerLike): number {
  if (typeof res.questionPointsSoFar === 'number' && !Number.isNaN(res.questionPointsSoFar)) {
    return res.questionPointsSoFar;
  }
  return stopLetterPointsFromProgress(res.foundCount, res.wrongCount);
}

